import { render, staticRenderFns } from "./DirectDeliveryList.vue?vue&type=template&id=03501c8e&scoped=true"
import script from "./DirectDeliveryList.vue?vue&type=script&lang=js"
export * from "./DirectDeliveryList.vue?vue&type=script&lang=js"
import style0 from "./DirectDeliveryList.vue?vue&type=style&index=0&id=03501c8e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03501c8e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Karl\\Code\\customs_clearance\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('03501c8e')) {
      api.createRecord('03501c8e', component.options)
    } else {
      api.reload('03501c8e', component.options)
    }
    module.hot.accept("./DirectDeliveryList.vue?vue&type=template&id=03501c8e&scoped=true", function () {
      api.rerender('03501c8e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/bill/DirectDeliveryList.vue"
export default component.exports